import {  createSlice } from '@reduxjs/toolkit';
import {CustomerDetail,CustomerDetailResponseState,SignModel,CustomerDetailClass} from '../models/CustomerModels'


const initialState:CustomerDetailResponseState = {
    customerDetailItem:new CustomerDetailClass()
}

const customerDetailSlice = createSlice({
    name:'user',
    initialState,
    reducers:{
        setCustomerDetail(state,action:{payload:CustomerDetail}){
            state.customerDetailItem = action.payload;
        }
    }
});

export const {
    setCustomerDetail,
} = customerDetailSlice.actions;

export default customerDetailSlice.reducer;